import { useState, useEffect } from "react";
import api from "../api";
import { useTheme } from "../components/Theme";
import { PERFIS, getPerfil, NAV_ITEMS } from "../components/Permissoes";

const ORANGE = "#E8520A";

function BadgePerfil({ role }) {
  const perfil = getPerfil(role);
  return (
    <span style={{ background: perfil.color + "22", color: perfil.color, border: `1px solid ${perfil.color}44`, borderRadius: 6, fontSize: 11, fontWeight: 700, padding: "2px 10px" }}>
      {perfil.emoji} {perfil.label}
    </span>
  );
}

function PerfilCard({ role, selected, onClick }) {
  const { theme } = useTheme();
  const perfil = getPerfil(role);
  return (
    <div onClick={onClick} style={{
      background: selected ? perfil.color + "18" : theme.bgInput,
      border: `2px solid ${selected ? perfil.color : theme.border}`,
      borderRadius: 10, padding: "12px 16px", cursor: "pointer", transition: "all .15s"
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
        <span style={{ fontSize: 18 }}>{perfil.emoji}</span>
        <span style={{ fontWeight: 700, color: selected ? perfil.color : theme.text, fontSize: 14 }}>{perfil.label}</span>
        {selected && <span style={{ marginLeft: "auto", color: perfil.color, fontSize: 16 }}>✓</span>}
      </div>
      <p style={{ margin: 0, fontSize: 12, color: theme.textMuted, lineHeight: 1.4 }}>{perfil.descricao}</p>
      <div style={{ marginTop: 8, display: "flex", flexWrap: "wrap", gap: 4 }}>
        {perfil.paginas.map(p => {
          const nav = NAV_ITEMS.find(n => n.id === p);
          return nav ? <span key={p} style={{ fontSize: 10, background: perfil.color + "22", color: perfil.color, borderRadius: 4, padding: "1px 6px" }}>{nav.emoji} {nav.label}</span> : null;
        })}
      </div>
    </div>
  );
}

function Modal({ user, onClose, onSave }) {
  const { theme } = useTheme();
  const isNew = !user?._id;
  const [form, setForm] = useState(user || { nome: "", email: "", senha: "", role: "vendedor", ativo: true });
  const [erro, setErro] = useState("");
  const [load, setLoad] = useState(false);
  const [aba, setAba]   = useState("dados");
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const inp = { width: "100%", boxSizing: "border-box", background: theme.bgInput, border: `1px solid ${theme.border}`, borderRadius: 8, padding: "9px 12px", color: theme.text, fontSize: 14, outline: "none", colorScheme: theme.name, fontFamily: "inherit" };

  const salvar = async () => {
    setErro(""); setLoad(true);
    try { await onSave(form); }
    catch (e) { setErro(e.response?.data?.erro || "Erro ao salvar"); }
    finally { setLoad(false); }
  };

  const perfil = getPerfil(form.role);

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.7)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }} onClick={onClose}>
      <div style={{ background: theme.bgCard, border: `1px solid ${theme.border}`, borderRadius: 16, padding: 28, width: "100%", maxWidth: 520, maxHeight: "90vh", overflowY: "auto" }} onClick={e => e.stopPropagation()}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
          <h2 style={{ margin: 0, fontSize: 18, fontFamily: "'Barlow Condensed',sans-serif", fontWeight: 900, letterSpacing: 2, color: theme.text }}>{isNew ? "NOVO USUÁRIO" : "EDITAR USUÁRIO"}</h2>
          <button onClick={onClose} style={{ background: "none", border: "none", color: theme.textMuted, fontSize: 22, cursor: "pointer" }}>×</button>
        </div>

        {/* Abas */}
        <div style={{ display: "flex", gap: 4, marginBottom: 16, borderBottom: `1px solid ${theme.border}`, paddingBottom: 12 }}>
          {[["dados", "📋 Dados"], ["perfil", "🔐 Perfil & Acesso"]].map(([id, label]) => (
            <button key={id} onClick={() => setAba(id)} style={{ padding: "5px 14px", borderRadius: 8, fontSize: 12, fontWeight: 600, cursor: "pointer", border: `1px solid ${aba === id ? ORANGE + "66" : theme.border}`, background: aba === id ? ORANGE + "22" : theme.bgInput, color: aba === id ? ORANGE : theme.textMuted }}>{label}</button>
          ))}
        </div>

        {/* ABA DADOS */}
        {aba === "dados" && (
          <>
            {[["Nome completo", "nome", "text"], ["Email", "email", "email"], ...(isNew ? [["Senha", "senha", "password"]] : [])].map(([label, key, type]) => (
              <div key={key} style={{ marginBottom: 14 }}>
                <label style={{ fontSize: 11, color: theme.textMuted, display: "block", marginBottom: 4, letterSpacing: ".04em", textTransform: "uppercase" }}>{label}</label>
                <input type={type} value={form[key] || ""} onChange={e => set(key, e.target.value)} style={inp} />
              </div>
            ))}
            {!isNew && (
              <div style={{ marginBottom: 14 }}>
                <label style={{ fontSize: 11, color: theme.textMuted, display: "block", marginBottom: 8, letterSpacing: ".04em", textTransform: "uppercase" }}>Status</label>
                <div style={{ display: "flex", gap: 8 }}>
                  {[[true, "✅ Ativo", "#10b981"], [false, "🚫 Inativo", "#ef4444"]].map(([val, lbl, color]) => (
                    <button key={String(val)} onClick={() => set("ativo", val)} style={{ flex: 1, padding: "8px 0", borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: "pointer", border: `1.5px solid ${form.ativo === val ? color : theme.border}`, background: form.ativo === val ? color + "22" : theme.bgInput, color: form.ativo === val ? color : theme.textMuted }}>{lbl}</button>
                  ))}
                </div>
              </div>
            )}
          </>
        )}

        {/* ABA PERFIL */}
        {aba === "perfil" && (
          <>
            <p style={{ fontSize: 13, color: theme.textMuted, marginBottom: 16 }}>Escolha o perfil de acesso. Cada perfil define quais telas o usuário pode ver e o que pode fazer.</p>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 16 }}>
              {Object.keys(PERFIS).map(role => (
                <PerfilCard key={role} role={role} selected={form.role === role} onClick={() => set("role", role)} />
              ))}
            </div>

            {/* Resumo do perfil selecionado */}
            <div style={{ background: perfil.color + "11", border: `1px solid ${perfil.color}33`, borderRadius: 10, padding: "12px 16px" }}>
              <div style={{ fontSize: 13, fontWeight: 600, color: perfil.color, marginBottom: 8 }}>{perfil.emoji} Resumo do perfil {perfil.label}</div>
              <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
                {[
                  ["Pode editar leads", perfil.podeEditar],
                  ["Pode excluir leads", perfil.podeExcluir],
                  ["Vê leads de todos", perfil.veLeadsDeTodos],
                  ["Pode criar usuários", perfil.podeCriarUsuarios],
                ].map(([label, val]) => (
                  <div key={label} style={{ display: "flex", justifyContent: "space-between", fontSize: 12 }}>
                    <span style={{ color: theme.textMuted }}>{label}</span>
                    <span style={{ color: val ? "#10b981" : "#ef4444", fontWeight: 700 }}>{val ? "✅ Sim" : "❌ Não"}</span>
                  </div>
                ))}
              </div>
            </div>
          </>
        )}

        {erro && <div style={{ color: "#ef4444", fontSize: 13, marginTop: 12 }}>{erro}</div>}

        <button onClick={salvar} disabled={load} style={{ width: "100%", marginTop: 16, background: ORANGE, border: "none", borderRadius: 10, padding: "12px 0", color: "#fff", fontWeight: 800, fontSize: 14, cursor: "pointer", fontFamily: "'Barlow Condensed',sans-serif", letterSpacing: 1, opacity: load ? .7 : 1 }}>
          {load ? "SALVANDO..." : "SALVAR"}
        </button>
      </div>
    </div>
  );
}

export default function Usuarios({ currentUser }) {
  const { theme } = useTheme();
  const [users, setUsers]     = useState([]);
  const [modal, setModal]     = useState(null);
  const [loading, setLoading] = useState(true);
  const [sucesso, setSucesso] = useState("");
  const [filtro, setFiltro]   = useState("");

  const carregar = async () => {
    try { const { data } = await api.get("/users"); setUsers(data); } catch {} finally { setLoading(false); }
  };
  useEffect(() => { carregar(); }, []);

  const salvar = async (form) => {
    if (form._id) { await api.put(`/users/${form._id}`, form); setSucesso("Usuário atualizado!"); }
    else { await api.post("/auth/registro", form); setSucesso("Usuário criado!"); }
    setTimeout(() => setSucesso(""), 3000);
    await carregar(); setModal(null);
  };

  if (currentUser?.role !== "admin") return (
    <div style={{ padding: 40, textAlign: "center", color: theme.textMuted, fontFamily: "'Barlow',sans-serif", background: theme.bg, minHeight: "100vh" }}>
      <div style={{ fontSize: 40, marginBottom: 12 }}>🔒</div>
      <p>Acesso restrito a administradores.</p>
    </div>
  );

  const filtrados = filtro ? users.filter(u => u.role === filtro) : users;

  return (
    <div style={{ padding: 24, fontFamily: "'Barlow',sans-serif", background: theme.bg, minHeight: "100vh" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20, flexWrap: "wrap", gap: 12 }}>
        <div>
          <h2 style={{ margin: 0, fontFamily: "'Barlow Condensed',sans-serif", fontWeight: 900, fontSize: 22, letterSpacing: 2, color: theme.text }}>TIME DE VENDAS</h2>
          <p style={{ margin: "4px 0 0", fontSize: 13, color: theme.textMuted }}>{users.length} usuário{users.length !== 1 ? "s" : ""} cadastrado{users.length !== 1 ? "s" : ""}</p>
        </div>
        <button onClick={() => setModal({})} style={{ background: ORANGE, border: "none", borderRadius: 8, padding: "8px 20px", color: "#fff", fontWeight: 800, fontSize: 13, cursor: "pointer", fontFamily: "'Barlow Condensed',sans-serif", letterSpacing: 1 }}>+ NOVO USUÁRIO</button>
      </div>

      {sucesso && <div style={{ background: "#10b98122", border: "1px solid #10b98144", borderRadius: 10, padding: "10px 16px", marginBottom: 16, color: "#10b981", fontSize: 13 }}>✅ {sucesso}</div>}

      {/* Resumo dos perfis */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 10, marginBottom: 20 }}>
        {Object.entries(PERFIS).map(([role, perfil]) => {
          const count = users.filter(u => u.role === role).length;
          return (
            <div key={role} onClick={() => setFiltro(filtro === role ? "" : role)} style={{ background: filtro === role ? perfil.color + "18" : theme.bgCard, border: `1px solid ${filtro === role ? perfil.color + "66" : theme.border}`, borderRadius: 10, padding: "12px 14px", cursor: "pointer", transition: "all .15s" }}>
              <div style={{ fontSize: 20, marginBottom: 4 }}>{perfil.emoji}</div>
              <div style={{ fontSize: 14, fontWeight: 700, color: filtro === role ? perfil.color : theme.text }}>{perfil.label}</div>
              <div style={{ fontSize: 22, fontWeight: 800, color: perfil.color, fontFamily: "'Barlow Condensed',sans-serif" }}>{count}</div>
              <div style={{ fontSize: 11, color: theme.textMuted }}>usuário{count !== 1 ? "s" : ""}</div>
            </div>
          );
        })}
      </div>

      {filtro && (
        <div style={{ marginBottom: 12, display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{ fontSize: 12, color: theme.textMuted }}>Filtrando por: <strong style={{ color: getPerfil(filtro).color }}>{getPerfil(filtro).emoji} {getPerfil(filtro).label}</strong></span>
          <button onClick={() => setFiltro("")} style={{ background: "none", border: "none", color: theme.textMuted, fontSize: 12, cursor: "pointer", textDecoration: "underline" }}>Limpar</button>
        </div>
      )}

      {loading ? <div style={{ color: theme.textMuted, textAlign: "center", padding: 40 }}>Carregando...</div> : (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: 12 }}>
          {filtrados.map(u => {
            const perfil = getPerfil(u.role);
            return (
              <div key={u._id} onClick={() => setModal(u)} style={{ background: theme.bgCard, border: `1px solid ${theme.border}`, borderRadius: 12, padding: "16px 18px", cursor: "pointer", opacity: u.ativo ? 1 : 0.5, borderLeft: `3px solid ${perfil.color}`, boxShadow: theme.name === "light" ? "0 1px 4px rgba(0,0,0,.06)" : "none", transition: "transform .15s" }}
                onMouseEnter={e => e.currentTarget.style.transform = "translateY(-1px)"}
                onMouseLeave={e => e.currentTarget.style.transform = "none"}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 10 }}>
                  <div style={{ width: 40, height: 40, borderRadius: 10, background: perfil.color + "22", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20 }}>{perfil.emoji}</div>
                  <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                    <span style={{ fontSize: 11, fontWeight: 600, padding: "2px 8px", borderRadius: 99, background: u.ativo ? "#10b98122" : "#ef444422", color: u.ativo ? "#10b981" : "#ef4444" }}>{u.ativo ? "Ativo" : "Inativo"}</span>
                  </div>
                </div>
                <div style={{ fontWeight: 700, color: theme.text, fontSize: 14, marginBottom: 2 }}>{u.nome}</div>
                <div style={{ fontSize: 12, color: theme.textMuted, marginBottom: 10 }}>{u.email}</div>
                <BadgePerfil role={u.role} />
                {u._id === currentUser?._id && <div style={{ fontSize: 11, color: theme.textMuted, marginTop: 6 }}>• Você</div>}

                {/* Permissões resumidas */}
                <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginTop: 10 }}>
                  {perfil.podeEditar  && <span style={{ fontSize: 10, background: "#10b98111", color: "#10b981", borderRadius: 4, padding: "1px 6px" }}>✏️ Editar</span>}
                  {perfil.podeExcluir && <span style={{ fontSize: 10, background: "#10b98111", color: "#10b981", borderRadius: 4, padding: "1px 6px" }}>🗑️ Excluir</span>}
                  {perfil.veLeadsDeTodos && <span style={{ fontSize: 10, background: "#6366f111", color: "#6366f1", borderRadius: 4, padding: "1px 6px" }}>👁️ Todos leads</span>}
                  {!perfil.podeEditar && <span style={{ fontSize: 10, background: "#f59e0b11", color: "#f59e0b", borderRadius: 4, padding: "1px 6px" }}>👁️ Só leitura</span>}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {modal !== null && <Modal user={Object.keys(modal).length ? modal : null} onClose={() => setModal(null)} onSave={salvar} />}
    </div>
  );
}
